import { mode } from '@chakra-ui/theme-tools';

export const progressStyles = {
  components: {
    Progress: {
      baseStyle: {
        track: {
          borderRadius: '20px',
        },
        filledTrack: {
          borderRadius: '20px',
        },
      },
      variants: {
        table: (props: Record<string, unknown>) => ({
          track: {
            borderRadius: '20px',
            bg: mode('blue.50', 'whiteAlpha.50')(props),
            h: '8px',
            w: '54px',
          },
          filledTrack: {
            bg: 'brand.500',
            borderRadius: '16px',
          },
        }),
      },
    },
  },
};
